module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_146.25deg.f2ab9556.png";